var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MainLayout',[_c('Hero'),_c('Ces',{attrs:{"id":"ces"}}),_c('UseCases',{attrs:{"id":"use-cases"}}),_c('Workspace',{attrs:{"id":"workspace"}}),_c('Contact',{attrs:{"id":"contact"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }